import { BaseResource } from '../../../base-resource';

export class Asset extends BaseResource {
  
}